export default __webpack_public_path__ + "static/media/eflex-rvb.347f57c8.svg";